import React from 'react';
import { reduxForm, Field } from 'redux-form';

import CheckboxField from 'components/CheckboxField';
import SelectField from 'components/SelectField';
import InputField from 'components/InputField';
import FormError from 'components/FormError';
import { nullifyChoice } from 'helpers/normalizers';
import { idsByMake } from 'helpers/preactivations';

import styles from './styles.module.scss';

const UpdateDeviceModalForm = ({
  sub,
  isAdmin,
  handleSubmit,
  error,
  isAtt,
  isSimo,
}) => {
  const showForceOption =
    isAtt &&
    isAdmin &&
    sub &&
    sub.synced_with_att &&
    sub.att_status === 'active';
  const platformOpts = [
    ['ios', 'iOS'],
    ['android', 'Android'],
  ];
  let statusOpts = [
    ['wing', 'Wing Device'],
    ['loaner', 'Wing Loaner Device'],
  ];

  const makeOptions = Object.keys(idsByMake).map((make) => [make, make]);

  if (isAdmin) {
    statusOpts.push(['testing', 'Internal Testing Device']);
  }

  const renderForm = () => {
    return (
      <div className={styles.attForm}>
        <div className={styles.item}>
          <Field component={InputField} name="device_id" label="Device ID" />
        </div>
        <div className={styles.item}>
          <Field
            component={SelectField}
            name="device_make"
            label="Device Brand"
            options={makeOptions}
            empty="Select brand"
            normalize={nullifyChoice}
          />
        </div>
        <div className={styles.item}>
          <Field
            component={SelectField}
            name="device_status"
            label="Device Status"
            options={statusOpts}
            empty="Select device status"
            normalize={nullifyChoice}
          />
        </div>
        <div className={styles.item}>
          <Field
            component={SelectField}
            name="platform"
            label="Platform"
            options={platformOpts}
            empty="Select platform"
            normalize={nullifyChoice}
          />
        </div>
        <div className={styles.item}>
          <Field component={InputField} name="icc_id" label="ICC ID" />
        </div>
        <div className={styles.item}>
          <Field component={InputField} name="remark" label="Remark" />
        </div>
        {showForceOption && (
          <div className={styles.item}>
            <Field component={CheckboxField} name="force" label="Force" />
          </div>
        )}
      </div>
    );
  };

  const renderSimoForm = () => {
    return (
      <React.Fragment>
        <Field component={InputField} name="device_sn" label="Device SN" />
        <Field
          component={CheckboxField}
          name="sync"
          label="Device already active"
        />
      </React.Fragment>
    );
  };

  return (
    <form onSubmit={handleSubmit}>
      {isSimo ? renderSimoForm() : renderForm()}

      {error && <FormError error={error} />}
      <br />
      <button className="btn btn-primary">Update Device</button>
    </form>
  );
};

const validate = (values, { isSimo, isQuick }) => {
  let errors = {};

  if (isSimo && !values.device_sn) {
    errors.device_sn = 'Required';
  }

  if (isQuick) {
    if (
      values.device_id &&
      !(
        15 <= values.device_id.trim().length &&
        values.device_id.trim().length <= 20
      )
    ) {
      errors.device_id = 'Device Id should be 15-20 digits long';
    } else if (values.device_id && !/^\d+$/.test(values.device_id)) {
      errors.device_id = 'Device Id should be a numeric value';
    }

    if (
      values.icc_id &&
      !(17 <= values.icc_id.trim().length && values.icc_id.trim().length <= 32)
    ) {
      errors.icc_id = 'ICC ID should be 17-32 digits long';
    } else if (values.icc_id && !/^\d+$/.test(values.icc_id)) {
      errors.icc_id = 'ICC ID should be a numeric value';
    }
  }

  return errors;
};

export default reduxForm({
  form: 'device',
  validate,
  enableReinitialize: true,
})(UpdateDeviceModalForm);
